@for (message of msgs; track message) {
  <p-message [life]="3000" [text]="message.detail"></p-message>
}

<form [formGroup]="srchCustomerForm">
  <div class="topsrchnav">
    <div class="ui-g form-group">
      <div class="ui-g-0 ui-md-2"></div>
      <div class="ui-g-12 ui-md-8">
        <div class="ui-inputgroup">
          <input
            type="text"
            class="input-customer-search"
            (keyup.enter)="search()"
            pInputText
            placeholder="Minimum 3 characters required"
            formControlName="txtCustomerSrch"
            id="txtCustomerSrch" />
          <button
            class="button-search"
            pButton
            type="button"
            (click)="search()"
            icon="ui-icon-search">
            Search
          </button>
        </div>
      </div>
      <div class="ui-g-0 ui-md-2"></div>
    </div>
  </div>
</form>

@if (customerList) {
  <form [formGroup]="chckCustomerForm" (ngSubmit)="onSubmit()">
    <div class="ui-g form-group">
      <div class="ui-g-12 ui-md-12">
        <div class="brdtable">
          <p-table
            [value]="customerList"
            [paginator]="true"
            [rows]="5"
            paginatorPosition="top">
            <ng-template #header let-columns>
              <tr>
                <th class="chwidth"></th>
                <th>Tenant Id</th>
                <th>Tenant Name</th>
                <th class="mpnwidth">TP Id</th>
                <th>TP Name</th>
              </tr>
            </ng-template>
            <ng-template #body let-customerList>
              <tr>
                <td>
                  <p-radioButton
                    name="tenantID"
                    [value]="customerList"
                    [(ngModel)]="selectedCustomer"
                    formControlName="tenantID"></p-radioButton>
                </td>
                <td>{{ customerList.tenantId }}</td>
                <td>{{ customerList.tenantName }}</td>
                <td>{{ customerList.tpId }}</td>
                <td>{{ customerList.tpName }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <div class="ui-g form-group">
        <div class="ui-g-12 ui-md-12">
          <button
            type="submit"
            [disabled]="selectedCustomer.length === 0 || btnDisable"
            pButton
            class="flat btnmr">
            Submit
          </button>
          <button
            type="button"
            pButton
            (click)="cancelSearchNav()"
            class="ui-button-secondary flat">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
}
